import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MenuItems } from '@core';

@Component({
    selector: 'app-route-planner',
    template: '',
    standalone: false
})
export class RoutePlannerComponent implements OnInit {
    private readonly router = inject(Router);


    ngOnInit(): void {
        this.router.navigateByUrl(`${MenuItems.routePlanner.path}/${MenuItems.routePlanner.children.planner.path}`);
    }
}
